// Primary navigation — the design IA (Jonathan.dc.html top bar /
// Jonathan-Mobile.dc.html bottom tabs): Today · Guests · Calendar · Your salon.
//
// Rendered as a desktop top bar on wide viewports and a bottom tab bar on
// mobile (the design ships both faces). The view bodies under each tab land in
// the C2–C5 beads; C1 establishes the shell + IA only.

const TABS = [
  {
    id: 'today',
    label: 'Today',
    icon: (
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: 'guests',
    label: 'Guests',
    icon: (
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4zm6 0a3 3 0 10-2.5-1.34" />
      </svg>
    ),
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: (
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: 'salon',
    label: 'Your salon',
    icon: (
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21V10l9-7 9 7v11a1 1 0 01-1 1h-5v-7H9v7H4a1 1 0 01-1-1z" />
      </svg>
    ),
  },
];

export function TabBar({ activeTab, onTabChange }) {
  return (
    <nav
      class="tab-bar fixed bottom-0 left-0 right-0 z-40"
      style={{
        background: 'var(--bg-glass, rgba(231,224,210,0.92))',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderTop: '1px solid var(--border-subtle)',
      }}
    >
      <div
        class="tab-bar-inner flex justify-around pt-2 mx-auto"
        style={{ maxWidth: '480px' }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              class={`relative flex flex-col items-center gap-1 px-5 py-2 bg-transparent border-none cursor-pointer font-sans ${
                isActive ? 'tab-active' : ''
              }`}
              style={{ color: isActive ? 'var(--olive)' : 'var(--text-secondary)' }}
            >
              {tab.icon}
              <span class="text-[0.6875rem] font-semibold whitespace-nowrap">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export { TABS };
